module.exports = __webpack_public_path__ + "resources/default_1.743892a273755d8a.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/default_1.png
// module id = 763
// module chunks = 0 2